"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackSpvAmountChange = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackSpvAmountChange = (eventName, productTitle, productCountChanged) => {
    const isCountIncreased = eventName === enums_1.GA4EventName.IncreaseCount;
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: isCountIncreased ? enums_1.GA4EventName.IncreaseCount : enums_1.GA4EventName.DecreaseCount,
            feature_category: enums_1.GA4FeatureCategory.DirectBooking,
            product_count_changed: productCountChanged,
            product_title: productTitle,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackSpvAmountChange = trackSpvAmountChange;
//# sourceMappingURL=trackSpvAmountChange.js.map